<div class="overlay">
  <div class="glow"></div>

  <div class="loader-box" #scrollContainer>
    <div *ngFor="let state of loadingStates; let i = index" class="step"
      [class.active]="i === currentStep && !completed" [class.done]="i < currentStep || completed" #stepItem>
      <!-- ICON -->
      <div class="icon">
        <!-- DONE -->
        <span *ngIf="i < currentStep || completed">✔</span>

        <!-- ACTIVE -->
        <span *ngIf="i === currentStep && !completed" class="spinner"></span>

        <!-- UPCOMING -->
        <span *ngIf="i > currentStep && !completed">○</span>
      </div>

      <!-- TEXT -->
      <div>{{ state.text }}</div>
    </div>
  </div>
</div>